import gql from 'graphql-tag'

const agentiSegretarie = gql`
  query utenti (
    $limit: Int!,
    $offset: Int
  ) {
    utenti (
      limit: $limit,
      offset: $offset,
      where: { 
        OR: [
          { ruolo: AGENTE }, 
          { ruolo: SEGRETARIA } 
        ]
      }
    ) {
      totalCount
      nodes {
        id
        nome
        email
        ruolo
      }
    }
  }
`

export default agentiSegretarie


// WEBPACK FOOTER //
// ./src/graphql/queries/agentiSegretarie.js